import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stk-account-presets-range',
  templateUrl: './stk-account-presets-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockAccountPresetsRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Input() canClear: boolean = false;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
